<template>
  <div class="mt-15 container-inner">
    <h3 class="title-type-2">
      <strong>{{ inventory.name }}</strong> 상품 세부 설정
    </h3>
    <div class="mb-8">
      <h4 class="title-type-3">
        지면설명
        <span class="attention-coment-1 ml-2">
          <v-icon>mdi-alert-circle</v-icon>
          내부 숏게임 연습장 이미지 광고
        </span>
      </h4>
    </div>
    <!-- 그룹코드 -->
    <div class="mb-8">
      <h4 class="title-type-3">그룹코드</h4>
      <div class="relative white rounded pa-6 pr-16">
        <div class="form-row-1">
          <p class="label">
            그룹 선택
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <v-select
              :items="searchGroupCode"
              label="선택"
              v-model="selGroup"
              item-color="#000"
              class="input-custom-2"
              height="40px"
              solo
              required
              hide-details
              @change="selGroupChecked(selGroup, searchGroupCode)"
            ></v-select>
          </div>
        </div>
      </div>
    </div>
    <!-- //그룹코드 -->
    <!-- 이미지 업로드 -->
    <div class="mb-8">
      <h4 class="mt-8 title-type-3">이미지 업로드</h4>
      <div class="resource-wrap">
        <ResourceImage1
          :propsInventoryType="inventory.type"
          :propsInventoryId="propsInventoryId"
          :propsInventory="inventory"
          :propsLineItemId="lineItemId"
          :propsLriId="lriId"
          :propsResources="resources"
          :propsAdvertiserId="propsAdvertiserId"
          @getResourceAfterAdd="updateDetailLineitemForResource"
          @getResourceAfterDelete="deleteDetailLineitemForResource"
        />
      </div>
    </div>
    <!-- //이미지 업로드 -->
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import SystemAlert from '~@/modal/SystemAlert.vue';
import { optionsList } from '@/api/options';

import {
  getDetailCampaignLineItem,
  addOptionItem,
  updateOptionItem,
} from '@/api/campaign';
import ResourceImage1 from './internalResourceImage1.vue';

export default {
  components: {
    ResourceImage1,
    SystemAlert,
  },
  props: {
    propsInventory: Object,
    propsInventoryId: String,
    propsLineItem: Object,
    propsDateRange: Object,
    propsAdvertiserId: String,
  },
  data: () => ({
    showSystemAlert: false,
    logResult: '',

    searchGroupCode: [],
    selGroup: '',
    optionsGroupMap: {},

    isValid: 'Y',

    options: [],
    optionItemsMap: {},

    lineItem: {},
    lineItemId: '',
    lris: [],
    lri: {},
    lriId: '',
    lrisMap: {},

    resources: [],
    defaultResource: {
      dateRange: { startDate: null, endDate: null },
      id: '',
      name: '',
      start_at: null,
      end_at: null,
      is_valid: '',
      type: 1,
      hash: '',
      file: '',
    },
    resourceId: '',
  }),
  computed: {
    inventory: {
      get() {
        return this.propsInventory || this.propsInventory;
      },
      set(value) {
        this.propsInventory = value;
      },
    },
    defaultStartAt() {
      return this.propsInventory.start_at;
    },
    defaultEndAt() {
      return this.propsInventory.end_at;
    },
  },
  methods: {
    async getOptions() {
      try {
        const { data } = await optionsList();
        this.options = data.list;
        const groupMap = {};
        const optionItemsArray = [];
        const optionItemsMap = {};
        (this.options || []).forEach(option => {
          if (option.name === '숏게임연습장' && !option.key) {
            option.items.forEach(item => {
              groupMap[item.name] = item;
            });
          }
          option.items.forEach(item => {
            optionItemsArray.push(item);
          });
        });

        (optionItemsArray || []).forEach(item => {
          optionItemsMap[item.id] = item;
        });

        this.optionsGroupMap = groupMap;

        this.searchGroupCode = Object.keys(groupMap);

        this.optionItemsMap = optionItemsMap;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getDetailLineItem(emitData) {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const LineItemId = this.propsLineItem.id;
      try {
        const { data } = await getDetailCampaignLineItem(
          campaignId,
          inventoryId,
          LineItemId,
        );
        this.lineItem = data.row.medias[0].inventories[0].lineitems[0];
        this.lineItemId = data.row.medias[0].inventories[0].lineitems[0].id;

        this.isValid = this.lineItem.is_valid;

        if (this.lineItem.lris.length > 0) {
          this.lris = this.lineItem.lris;
          this.lri = this.lineItem.lris[0];
          this.lriId = this.lineItem.lris[0].id;
          this.resources = this.lineItem.lris[0].resources;

          //그룹코드를 선택하고 리소스가 없을 시
          if (this.lriId && this.resources.length === 0) {
            this.defaultResource.dateRange.startDate = this.defaultStartAt;
            this.defaultResource.dateRange.endDate = this.defaultEndAt;
            this.defaultResource.start_at = this.defaultStartAt;
            this.defaultResource.end_at = this.defaultEndAt;
            this.resources.push(
              JSON.parse(JSON.stringify(this.defaultResource)),
            );
          }

          //그룹 코드 세팅
          if (this.lri.item_id) {
            this.selGroup = this.optionItemsMap[this.lri.item_id].name;
          }
        }

        //resources 갱신
        if (emitData) {
          this.lris.forEach(lri => {
            if (lri.id === emitData.lriId) {
              this.resources = lri.resources;
            }
          });
          //resource가 없을 땐 defaultResource 넣어줌
          if (this.resources.length === 0 || !this.resources[0].id) {
            this.resources = [];
            this.defaultResource.dateRange.startDate = this.defaultStartAt;
            this.defaultResource.dateRange.endDate = this.defaultEndAt;
            this.defaultResource.start_at = this.defaultStartAt;
            this.defaultResource.end_at = this.defaultEndAt;
            this.resources.push(
              JSON.parse(JSON.stringify(this.defaultResource)),
            );
          }
          this.$emit('upadate:campaignInfo');
        }

        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    selGroupChecked(value) {
      let lriData = {
        item_id: this.optionsGroupMap[value].id,
      };
      if (this.lris.length > 0) {
        this.updateLri(lriData);
      } else {
        this.addLri(lriData);
      }
    },

    async addLri(lriData) {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.lineItemId;

      try {
        const { data } = await addOptionItem(
          campaignId,
          inventoryId,
          lineItemId,
          lriData,
        );
        if (data.result === 'success') {
          this.lriId = data.value;
          await this.getDetailLineItem();
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'IsAlreadyReserved') {
          this.showSystemAlert = true;
          this.logResult = '선택된 지면은 현재 집행중인 <br>캠페인이 있습니다.';
          this.selGroup = '';
          await this.getDetailLineItem();
        }
      }
    },
    async updateLri(lriData) {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.lineItemId;
      const lriId = this.lri.id;
      try {
        const { data } = await updateOptionItem(
          campaignId,
          inventoryId,
          lineItemId,
          lriId,
          lriData,
        );
        this.$forceUpdate();
        await this.getDetailLineItem();
      } catch (error) {
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'IsAlreadyReserved') {
          this.showSystemAlert = true;
          this.logResult = '선택된 지면은 현재 집행중인 <br>캠페인이 있습니다.';
          await this.getDetailLineItem();
        }
      }
    },
    updateDetailLineitemForResource(data) {
      this.getDetailLineItem(data);
    },
    deleteDetailLineitemForResource(data) {
      this.getDetailLineItem(data);
    },
    cancel() {
      this.$emit('close:detail', this.propsInventory);
    },
  },
  async created() {
    bus.$emit('start:spinner');
    await this.getOptions();
    await this.getDetailLineItem();
  },
};
</script>

<style scoped></style>
